import { Button, Card, Col, InputNumber, Modal, Row } from 'antd';
import { isNull } from 'lodash';
import React, { useEffect, useState } from 'react';
import { Page } from 'react-pdf';
import { useQuery } from 'react-query';
import { Document } from 'react-pdf/dist/esm/entry.webpack';
import { RightOutlined, LeftOutlined } from '@ant-design/icons';
import { API_URLS } from 'utils/config';
import { downloadBlobFile, getURLFile } from 'utils/utils2';
import ButtonOperation from 'components/ButtonOperation';

const PreviewDocModal = ({ setVisible, visible, conseq }: any) => {
  const PRINTING_URL = API_URLS.PRINTING;

  const [scale, setscale] = useState(1.1);
  const [url, seturl] = useState('initialState');

  const [Params, setParams] = useState<any>({
    isLoading: false,
    objectname: '',
    previewImage: '',
    previewVisibleDOC: false,
    previewTitle: '',
    isPDF: false,
    showAddDocument: false,
    doccode: '',
    doctype: '',
    loadingUpload: false,
    enableUpload: false,
    ok: true,
  });

  const getUrl = (printid: number) =>
    `${PRINTING_URL}/api/print/download?printid=${printid}`;

  const handlePreviewDOC = (fileurl: any) => {
    let ext = fileurl.substring(fileurl.lastIndexOf('.') + 1);

    setParams({
      previewVisibleDOC: true,
      previewTitle: fileurl.substring(fileurl.lastIndexOf('/') + 1),
      previewImage: fileurl,
      isPDF:
        conseq.conseqtype === 'EMAIL' ? false : ext === 'pdf' ? true : false,
    });
  };
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  function changePage(offset: number) {
    setPageNumber((prevPageNumber) => prevPageNumber + offset);
  }

  function previousPage() {
    changePage(-1);
  }

  function nextPage() {
    changePage(1);
  }
  const handleCancelPreviewDOC = () => setVisible(false);

  const onChangepdfZoom = (value: any) => {
    setscale(value / 100);
  };
  const [info, setinfo] = useState('');

  function onDocumentLoadSuccess({ numPages }: any) {
    setinfo('');
    setNumPages(numPages);
  }

  useEffect(() => {
    handlePreviewDOC(
      `${conseq.conseqcode}-${conseq.entity}-${conseq.entityid}-${conseq.conseqid}.pdf`
    );
  }, []);

  const { data, isFetching } = useQuery(
    [
      'getURLFile',
      `${conseq.conseqcode}-${conseq.entity}-${conseq.entityid}-${conseq.conseqid}.pdf`,
      `${PRINTING_URL}/api/print/document?doccode=${conseq.conseqcode}&entity=${
        conseq.entity
      }&entityid=${conseq.entityid}&conseqid=${conseq.conseqid}&subentity=${
        conseq.subentity
      }&subentityid=${isNull(conseq.subentityid) ? '' : conseq.subentityid}`,
    ],
    () =>
      getURLFile('item.cireference.pdf', getUrl(conseq.printid)).then((res) =>
        seturl(res)
      ),
    { enabled: conseq != null }
  );

  return (
    <Modal
      visible={visible}
      onCancel={() => {
        setVisible(false);
      }}
      width={1000}
      destroyOnClose
      onOk={() => {
        setVisible(false);
      }}
    >
      <Card>
        <Row>
          {Params.previewVisibleDOC && (
            <Col span={24}>
              <Row style={{ marginBottom: 10 }}>
                <Col>
                  <ButtonOperation
                    comcode="closePreview"
                    onClick={handleCancelPreviewDOC}
                  />
                </Col>
                <Col>
                  {conseq && (
                    <ButtonOperation
                      type="primary"
                      comcode="downloadfile"
                      onClick={(ev) => {
                        ev.preventDefault();
                        downloadBlobFile(
                          `${conseq.conseqcode}-${conseq.entity}-${conseq.entityid}-${conseq.conseqid}.pdf`,
                          `${PRINTING_URL}/api/print/download?printid=${conseq.printid}`
                        );
                      }}
                    />
                  )}
                </Col>
              </Row>
              <Row>
                {Params.previewVisibleDOC && (
                  <Col span={24}>
                    <Card>
                      <Row justify="center">
                        {Params.isPDF && (
                          <div>
                            <Row>
                            { numPages != null
                              && <> 
                              <Col span={2}>
                                <Button
                                  onClick={previousPage}
                                  icon={<LeftOutlined />}
                                  style={{ color: '#3755ac' }}
                                  disabled={numPages ? pageNumber <= 1 : false}
                                />
                                </Col>
                                <Col span={3}>                             
                               <p style={{marginTop: '7px'}}>
                                 Page {pageNumber} of {numPages}
                               </p>
                            </Col>
                            <Col span={2}>
                              <Button
                                disabled={
                                  numPages ? pageNumber >= numPages : false
                                }
                                onClick={nextPage}
                                icon={<RightOutlined />}
                                name="next"
                              />
                            </Col>
                            
                              <Col>
                                <InputNumber
                                  min={10}
                                  max={200}
                                  formatter={(value) => `${value}%`}
                                  step={10}
                                  defaultValue={100}
                                  onChange={onChangepdfZoom}
                                />
                              </Col>
                              </>}
                            </Row>

                            <Row justify="center">
                              <Document
                                file={url}
                                onLoadSuccess={onDocumentLoadSuccess}
                                onLoadError={() =>
                                  setinfo('THERE IS NO PDF FOR THIS PRINTID')
                                }
                              >
                               <Page pageNumber={pageNumber} scale={scale} />
                              </Document>
                            </Row>

                            
                          </div>
                        )}

                        {!Params.isPDF && (
                          <iframe
                            title="my_iframe"
                            name="my_iframe"
                            srcDoc={url}
                            width="100%"
                            height="800px"
                            style={{ border: '1px solid #E3E3E3' }}
                          />
                        )}
                      </Row>
                    </Card>
                  </Col>
                )}
              </Row>
            </Col>
          )}
        </Row>
      </Card>
    </Modal>
  );
};

export default PreviewDocModal;
